import React, { useEffect, useRef, useState } from 'react'
import {Input, Table, message, Col, Row, ConfigProvider, Pagination, Tabs, Button, Popconfirm, Modal, Tooltip,} from 'antd'
import { sendHttpPostRequest } from '../../../api/http-request'
import courseMainStyles from '../course-main.module.less'
import '../course.module.css'
import zhCN from 'antd/lib/locale/zh_CN'
import { checkUserLogin } from '../../common/user-center/user-info'
import globalStyles from "../../common/global-styles/idatacourse-table.module.less"
import { SearchOutlined} from '@ant-design/icons'
const { TabPane } = Tabs
import Cookies from 'js-cookie'


import moduleStyles from '../../oam/module/module.module.less'
import Draggable from 'react-draggable'
import shiyanEmpty from '../../../static/image/empty/queshengye-shiyan.png'
import { useHistory } from 'react-router-dom'

import slidesStyles from '../slides/course-main-teacher-slides.module.less'
import caseStyles from '../../case/case.module.less'
import defaultCaseCover from '../../../static/image/case/default_case_cover.png'
import * as constants from '../../../constants/constants'

import Icon from '@ant-design/icons'
import  {ReactComponent as mydeleteSvg }   from '../../../static/image/course/mydelete.svg'
const mydeleteIcon = (props:any) => (<Icon component={mydeleteSvg} {...props} />)
import  {ReactComponent as myplusSvg }   from '../../../static/image/course/myplus.svg'
const myplusIcon = (props:any) => (<Icon component={myplusSvg} {...props} />)
import { ReactComponent as eyeSvg }   from '../../../static/image/module/eye.svg'
const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)
import  {ReactComponent as closeeyeSvg }   from '../../../static/image/course/closeeye.svg'
const closeeyeIcon = (props:any) => (<Icon component={closeeyeSvg} {...props} />)

import  {ReactComponent as coderunSvg }   from '../../../static/image/course/coderun.svg'
const coderunIcon = (props:any) => (<Icon component={coderunSvg} {...props} />)


export interface Props {
  course_id: any
  is_course_teacher: any
  course?:any
}
/** 教师课程实验列表页面 */
export const CourseMainTeacherCases: React.FC<Props> = (props) => {
  const { course_id, is_course_teacher,course } = props
  const [casesList, setCasesList] = useState([] as any[]) //课程的实验
  const [addCaseVisible, setAddCaseVisible] = useState(false)
  const caseQueryContent = useRef('') // 记录搜索串
  const casePage = useRef(1) // 记录当前的页数
  const casePageSize = useRef(10) // 记录当前每页展示数量
  const [caseTotalSum, setCaseTotalSum] = useState(0) // 搜索返回的结果数
  const queryCaseIsMy = useRef('2') // 搜索实验的来源， 来源 1 我的  2 系统
  const caseOrder = useRef('') // 排序升序降序
  const caseOrderBy = useRef('') // 排序列
  const [caseTotalCount, setCaseTotalCount] = useState(0) // 搜索返回的结果数
  const [caseData, setCaseData] = useState([] as any[])
  const selectedCaseRows = React.useRef([] as any) //选择的实验

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)
  const draggleRef = useRef<HTMLDivElement | null>(null)
  let history = useHistory()

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  const queryCases = () => {
    sendHttpPostRequest(
      'course/api/user_query_course_info',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
      },
      (response: any) => {
        if (response.is_ok) {
          setCasesList(response.query_info.case_list)
        }
      }
    )
  }

  const onPreviewCase = (id: string, event: any) => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      event.preventDefault()
      window.open('/case-detail?case_id=' + id)
    }
  }

  const renderCaseActions = (text: any, record: any) => {
    return (
      <Button
        //className={courseCreateStyles.modalBtn}
        type="default"
        size="small"
        style={{ width: 50, borderRadius: 20, fontSize: 14, margin:0}}
        onClick={onPreviewCase.bind(this, record.case_id)}
      >
        预览
      </Button>
    )
  }

  const onDeleteCaseClick = (caseId: any) => {
    const newCaseList = casesList.filter((item) => item.id !== caseId)
    console.log(newCaseList)
    setCasesList(newCaseList)
    deleteCase(caseId)
  }

  const deleteCase = (caseId: any) => {
    sendHttpPostRequest(
      'course/api/user_delete_course_case',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        case: JSON.stringify([caseId]),
        course_id: course_id,
      },
      (response: any) => {
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/login?next=course-main-teacher?course_id=' + course_id;
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
          // window.location.href = '/login?next=course';
        } else if (response.is_ok == true) {
          message.success('课程实验删除成功~')
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 查案例列表
  const queryCaseList = () => {
    sendHttpPostRequest(
      'case/api/query_case_list',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        query: caseQueryContent.current,
        page: casePage.current,
        pagesize: casePageSize.current,
        is_my: queryCaseIsMy.current,
        order: caseOrder.current,
        order_by: caseOrderBy.current,
      },
      (response: any) => {
        if (response.is_ok && response.code == 0) {
          setCaseData(response.case_list)
          setCaseTotalSum(response.total_sum)
          setCaseTotalCount(response.total_count)
        } else {
          console.error('查询案例出错了')
        }
      }
    )
  }

  // 点击开关
  const onSwitchClick = (slidesId: number, openStatus: number) => {
    const newCasesList = [...casesList]
    newCasesList.map((item) => {
      if (item.id == slidesId) {
        item.open = openStatus == 0 ? 1 : 0
      }
    })
    setCasesList(newCasesList)
    saveCourse(newCasesList)
  }

  // 案例点击了搜索
  const onCaseSearchBtn = (e: any) => {
    casePage.current = 1
    caseQueryContent.current = e.target.value
    queryCaseList()
  }

  // 实验结果表格发生变化
  const onCaseTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      caseOrder.current = sorter.order
      caseOrderBy.current = sorter.field
    }

    casePage.current = 1
    queryCaseList()
  }

  // 选择实验
  const caseRowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      selectedCaseRows.current = selectedRows
    },
    getCheckboxProps: (record: any) => ({
      disabled:
        casesList?.filter((item) => item.id == record.case_id).length > 0,
      //name: record.name,
    }),
  }

  /** 确认添加实验 */
  const handleAddCaseOk = () => {
    setAddCaseVisible(false)
    queryCaseIsMy.current = '2'
    const newCaseList = [...casesList]

    selectedCaseRows.current.map((row) => {
      newCaseList.push({
        id: row.case_id,
        name: row.name,
        open: 0,
        token: row.token,
      })
    })

    setCasesList(newCaseList)
    saveCourse(newCaseList)
  }

  // 搜索切换Tab页
  const onCaseTabKeyChange = (key: string) => {
    queryCaseIsMy.current = key
    casePage.current = 1
    queryCaseList()
  }

  /**
   * 创建课程回调
   * @param response
   */
  const saveCourseInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=course';
    } else if (response.code == -501) {
      // 没权限
      message.error('权限不足')
      // window.location.href = '/login?next=course';
    } else if (response.is_ok == true) {
      //message.success("课程信息保存成功~")
      queryCases()
    } else {
      message.error(response.message)
    }
  }

  const caseModalCols: any = [
    {
      title: 'ID',
      dataIndex: 'case_id',
      key: 'case_id',
      align: 'center',
      width: 80,
    },
    {
      title: '实验名称',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      width: 200,
      ellipsis: true,
    },
    {
      title: '领域',
      dataIndex: 'domain',
      key: 'domain',
      align: 'center',
      width: 100,
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 150,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 100,
      ellipsis: true,
      align: 'center',
      render: renderCaseActions,
    },
  ]

  /**
   * 点击保存课程按钮
   */
  const saveCourse = (caseList: any) => {
    sendHttpPostRequest(
      'course/api/user_update_course',
      {
        name: course?.name,
        course_id: course_id,
        case: JSON.stringify(caseList),
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      saveCourseInfoCallback
    )
  }

  const routeToCaseRun = (record: any, case_id: number, course_id?: any) => {
    if (!record?.is_system) {
      window.open(`/course-case-run?case_id=${case_id}?course_id=${course_id}`)
    } else {
      window.open(`/case-run?case_id=${case_id}`)
    }
  }

  const onRunCaseBtnClick = (record: any) => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (record.is_system) {
      let params = {
        case_id: record.id,
        course_id: course_id,
      }
      sendHttpPostRequest(
        'course/api/user_get_or_fork_course_case_by_id',
        params,
        (res) => {
          if (res.code == 0) {
            routeToCaseRun(record, res.case_info.case_id, course_id)
            queryCases()
          } else {
            message.error(res.message)
          }
        }
      )
    } else {
      routeToCaseRun(record, record.id, course_id)
    }
  }
  const onPreviewCaseBtnClick = (record: any) => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      window.open(
        `/course-case-detail?case_id=${record.id}&course_id=${course_id}`
      )
    }
  }



  useEffect(() => {
    queryCases()
  }, [])

  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    casePage.current = newPage ? newPage : 1
    if (newPageSize) {
      casePageSize.current = newPageSize
    }
    queryCaseList()
  }

  return (
    <div >

        <Row wrap={false} align={"middle"} style={{margin: '0 0 24px'}}>
          <Col span={12} style={{textAlign:'left'}}>
              <div className={courseMainStyles.courseTabContentTitle}>实验管理</div>
          </Col>

          <Col span={12} style={{textAlign:'right'}}>
            <div >
              {is_course_teacher && (
                <span
                    style={{fontSize:14, padding:'4px 12px'}}
                    className={courseMainStyles.BtnDark}
                    onClick={() => {
                      queryCaseList()
                      selectedCaseRows.current = []
                      setAddCaseVisible(true)
                    }}
                >
                  <Icon component={myplusIcon}/> 添加实验
                </span>
              )}
    
            </div>
          </Col>
      </Row>



      <Row gutter={[24, 24]} justify="start"  align="middle" wrap={true}>
        {casesList?.map((caseInterface) => {
          return (
            <Col span={6} key={caseInterface.case_id}>
              <div 
                className={caseStyles.caseCard} style={{height:'100%', width:'100%',border: '1px solid #e5e7eb'}}
              >

                <div className={caseStyles.caseCardCoverDiv} style={{height:100}}>

                    {caseInterface.cover == '' ? (
                      <img
                        alt=""
                        src={defaultCaseCover}
                        height={'100%'}
                        width={'100%'}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    ) : (
                      <img
                        alt=""
                        src={
                          caseInterface.cover?.startsWith('http')
                            ? caseInterface.cover
                            : constants.BACKEND_URL +
                              caseInterface.cover
                        }
                        height={'100%'}
                        width={'100%'}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    )}
                </div>
                
                <div className={caseStyles.caseCardContentDiv} style={{height:'100%'}}>

                  <div
                      style={{
                        textAlign: 'left',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        marginBottom:0
                      }}
                      title={caseInterface.name}

                      className={caseStyles.caseTitle}
                    >
                      {caseInterface.name}
                    </div>

                       
                </div>


                <Row wrap={false} align="middle" className={slidesStyles.actionDiv} style={{borderRadius:'0 0 12px 12px'}}>
                    <Col span={12} style={{textAlign:'left'}}>
                      <div>
                        <span className={slidesStyles.openLabel}
                         style={{color: caseInterface?.open == 0 ? "#4b5563":"#07c160", background: caseInterface?.open == 0 ? "#4b55631a":"#07c1601a" }}>
                        {caseInterface?.open == 0? '未开放':'已开放'}
                        </span>
                        </div>
                    </Col>
                    <Col span={12} style={{textAlign:'right'}}>
                      <div>
                          <span title="查看" className={slidesStyles.actionIconWrapper}
                          
                          onClick={onPreviewCaseBtnClick.bind(this, caseInterface)}
                           
                          ><Icon component={eyeIcon}/></span>  

                          <span title="运行" className={slidesStyles.actionIconWrapper}
                          
                          onClick={onRunCaseBtnClick.bind(this, caseInterface)}
                           
                          ><Icon component={coderunIcon}/></span>  
                          <Popconfirm
                            placement="top"
                            title={'确认删除实验"' + caseInterface?.name + '"吗？'}
                            onConfirm={onDeleteCaseClick.bind(this, caseInterface.id)}
                            okText="确认"
                            cancelText="取消"
                          >
                            <span title="删除" className={slidesStyles.deleteIconWrapper} ><Icon component={mydeleteIcon}/></span> 
                          </Popconfirm>
                          

                          <span title={caseInterface?.open == 0 ?"设置为开放":"设置为不开放"} 
                           onClick={onSwitchClick.bind(this, caseInterface?.id, caseInterface?.open)}
                          className={slidesStyles.actionIconWrapper} 
                          ><Icon component={caseInterface?.open == 0 ? eyeIcon : closeeyeIcon}/></span>
                      </div>
                    </Col>
                  </Row>
            </div>
            </Col>
          )
        })}
      </Row>

        {casesList.length == 0 && (
          <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <img src={shiyanEmpty} width={120} height={120} />
            <div style={{ color: '#999', marginTop: 10 }}>
              您还没有添加实验哟~
            </div>
          </div>
        )}


      <ConfigProvider locale={zhCN}>
        <Modal
          title={
            <div
              style={{ width: '100%', cursor: 'move' }}
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false)
                }
              }}
              onMouseOut={() => {
                setDisabled(true)
              }}
              onFocus={() => {}}
              onBlur={() => {}}
            >
              添加实验
            </div>
          }
          open={addCaseVisible}
          width={800}
          bodyStyle={{ minHeight: 400, overflow: 'auto', paddingBottom:10 }}
          onOk={handleAddCaseOk}
          onCancel={() => {
            queryCaseIsMy.current = '2'
            setAddCaseVisible(false)
          }}
          destroyOnClose={true}
          closable={false}
          modalRender={(modal) => (
            <div className={moduleStyles.addModal}>
              <Draggable
                disabled={disabled}
                bounds={bounds}
                onStart={(event, uiData) => onStart(event, uiData)}
              >
                <div ref={draggleRef}>{modal}</div>
              </Draggable>{' '}
            </div>
          )}
        >
          <div>
            <Input
              onPressEnter={onCaseSearchBtn}
              placeholder="搜索实验"
              style={{ borderRadius: 20, width: 300, marginBottom: 10 }}
              suffix={<SearchOutlined style={{ color: '#666666' }} />}
            />
          </div>

          <Tabs defaultActiveKey="2" onChange={onCaseTabKeyChange}>
            <TabPane tab="平台" key="2" className="">
              <div style={{height:450}} className={globalStyles.tableWrapper}>
                <ConfigProvider locale={zhCN}>
                  <Table
                    dataSource={caseData}
                    columns={caseModalCols}
                    rowKey={(record) => record.case_id}
                    pagination={false}
                    size="small"
                    onChange={onCaseTableChange}
                    rowSelection={{
                      type: 'checkbox',
                      ...caseRowSelection,
                    }}
                  />
                </ConfigProvider>
              </div>
            </TabPane>
            <TabPane tab="我的" key="1" className="">
              <div style={{height:450}} className={globalStyles.tableWrapper}>
                <ConfigProvider locale={zhCN}>
                  <Table
                    dataSource={caseData}
                    columns={caseModalCols}
                    rowKey={(record) => record.case_id}
                    pagination={false}
                    size="small"
                    onChange={onCaseTableChange}
                    rowSelection={{
                      type: 'checkbox',
                      ...caseRowSelection,
                    }}
                  />
                </ConfigProvider>
              </div>
            </TabPane>
          </Tabs>

          <ConfigProvider locale={zhCN}>
            <div style={{textAlign:'center'}}>
              <Pagination
                defaultCurrent={1}
                total={caseTotalSum}
                current={casePage.current}
                defaultPageSize={10}
                hideOnSinglePage={true}
                showSizeChanger={false}
                onChange={onPageChange}
              />
            </div>
          </ConfigProvider>
        </Modal>
      </ConfigProvider>
    </div>
  )
}

export default CourseMainTeacherCases
